module.exports = {
  footerText: 'Copyright me:devs © 2023',
  footerLink: 'https://medevs.com/'
}
